export class ExportComplianceReportRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "format",
            "baseName": "format",
            "type": "ExportComplianceReportRequestFormatEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ExportComplianceReportRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var ExportComplianceReportRequestFormatEnum;
(function (ExportComplianceReportRequestFormatEnum) {
    ExportComplianceReportRequestFormatEnum["Pdf"] = "pdf";
    ExportComplianceReportRequestFormatEnum["Csv"] = "csv";
})(ExportComplianceReportRequestFormatEnum || (ExportComplianceReportRequestFormatEnum = {}));
